import { createClient } from '@supabase/supabase-js'

// Use environment variables with fallbacks
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://ccicgmkstfczcrdvduzz.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNjaWNnbWtzdGZjemNyZHZkdXp6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI4MDQ2OTUsImV4cCI6MjA4ODM4MDY5NX0.5b30ZI432eWEuVlgNqOVpJTiEQ3r2C68ER4X7JAKtFk'
console.log('🔧 Supabase Client Configuration:')
console.log('Environment:', process.env.NODE_ENV || 'development')
console.log('URL:', supabaseUrl)
console.log('Anon Key:', supabaseAnonKey ? '✓ Exists' : '✗ Missing')

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage
  }
})

console.log('✅ Supabase client initialized successfully')